import React, {forwardRef, useImperativeHandle, useState} from 'react';
import PropTypes from 'prop-types';
import {Modal, message} from 'antd';
import {useParams} from 'react-router-dom';
import _ from 'lodash';
import ExtraNewsWrapper, {ExtraNewsStoreProvider} from './context';
import ExtraNewsFormWrapper from './ExtraNewsFormWrapper';
import {INIT_NEWS} from './initFormData';
import {getNewsById} from './extra-news';

const ExtraNewsFormModal = forwardRef(({pageGridRef}, ref) => {
    const [visible, setVisible] = useState(false);
    const {appId} = useParams();

    function initNewsData() {
        const initTmpId = _.uniqueId();
        return {
            appId,
            currentTmpId: initTmpId,
            newsById: {
                [initTmpId]: {...INIT_NEWS},
            },
            tmpIds: [initTmpId],
        };
    }

    // 由于可能是多图文，所以对于每个图文都提供一个临时 id
    const [extraNewsData, setExtraNewsData] = useState(initNewsData());

    function showModal(newsId) {
        setVisible(true);

        if (newsId) {
            getNewsById(newsId).then(({data}) => {
                // console.log('hello', data);
                const {id, appId, items} = data;
                if (_.isEmpty(items)) {
                    message.warn('数据载入出错，请重试');
                    return;
                }

                setExtraNewsData({
                    id,
                    appId,
                    currentTmpId: items[0].id,
                    tmpIds: items.map(({id}) => id),
                    newsById: items.reduce((previousValue, currentValue) => {
                        return {
                            ...previousValue,
                            [currentValue.id]: currentValue,
                        };
                    }, {}),
                });
            });
        } else {
            setExtraNewsData(initNewsData());
        }
    }

    function closeModal() {
        setVisible(false);
    }

    useImperativeHandle(ref, () => ({
        showModal,
        closeModal,
    }));

    return (
        <Modal
            destroyOnClose
            maskClosable={false}
            visible={visible}
            title="上传图文"
            width={1000}
            closable={false}
            keyboard={false}
            onCancel={closeModal}
            footer={null}
        >
            <ExtraNewsStoreProvider>
                <ExtraNewsWrapper initialValues={extraNewsData}>
                    <ExtraNewsFormWrapper closeModal={closeModal} pageGridRef={pageGridRef} />
                </ExtraNewsWrapper>
            </ExtraNewsStoreProvider>
        </Modal>
    );
});

ExtraNewsFormModal.displayName = 'ExtraNewsFormModal';

ExtraNewsFormModal.propTypes = {
    pageGridRef: PropTypes.object,
};

export default ExtraNewsFormModal;
